<template>
  <div>
	  <a href='https://1500005170.vod2.myqcloud.com/6c9a33d5vodcq1500005170/d55c9ac23701925921670943090/f0.mp4' download="w3logo">
	  <img border="0" src="/i/w3school_logo_white.gif" alt="W3School">
	  </a>
	  <el-button size="mini" style="margin-right: 10px"
	                    ><a @click="handleDownloads()"
	                      >下载</a
	                    ></el-button >

    <ul class="ulBox" id="ulBox" @click="aaaa()">
      <li class="li" :id="'id'+item" v-for="(item,index) in list" :key="index">
        {{item}}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
  data() {
    return {
      list: [1,2,3,4,5,6,7,8,9],
    };
  },
  created() {
	  let url='http://1500005170.vod2.myqcloud.com/6c9a33d5vodcq1500005170/d20621413701925918797879547/f0.mp4'
	window.open('http://1500005170.vod2.myqcloud.com/6c9a33d5vodcq1500005170/d20621413701925918797879547/f0.mp4')
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  methods: {
	  handleDownloads() {
		  /* handleFileDownload = (url, filename) => {
		    // 创建 a 标签
		    let a = document.createElement('a');
		    a.href = url;
		    a.download = filename;
		    a.click();
		  } */
		  var name = 'pt3';
		      var url = 'https://1500005170.vod2.myqcloud.com/6c9a33d5vodcq1500005170/d55c9ac23701925921670943090/f0.mp4';
		      var suffix = url.substring(url.lastIndexOf("."), url.length);
		        //跳过浏览直接下载
		      fetch(url)
		          .then(res => res.blob())
		          .then(blob => {
		          const a = document.createElement("a");
		          const objectUrl = window.URL.createObjectURL(blob);
		          a.download = name;
		          a.href = objectUrl;
		          a.click();
		          window.revokeObjectURL(objectUrl);
		      })
		  console.log(1234)
		  /* let fileName='https://1500005170.vod2.myqcloud.com/6c9a33d5vodcq1500005170/d55c9ac23701925921670943090/f0.mp4'
		  window.location.href = baseURL + "/common/download?fileName=" + encodeURI(fileName) + "&delete=" + true */

	       /* window.location.href('https://1500005170.vod2.myqcloud.com/6c9a33d5vodcq1500005170/d55c9ac23701925921670943090/f0.mp4'); */
	      },
	  aaaa(){
		  window.open('https://1500005170.vod2.myqcloud.com/6c9a33d5vodcq1500005170/d55c9ac23701925921670943090/f0.mp4')
		  /* window.location.href =("https://1500005170.vod2.myqcloud.com/6c9a33d5vodcq1500005170/4cd734bf3701925919958255899/f0.mp4") */
	  },
    scrollToTop() {
      // 获取视窗高度
      var domHight = document.body.offsetHeight;
      // dom滚动位置
      var scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
	  console.log('2222',scroll)
      // 获取监听元素
      var id;
      // 获取监听元素本身高度
      var scrollHeight;
      // 获取监听元素距离视窗顶部距离
      var offsetTop;
      // 获取监听元素距离顶部高度-窗口高度 
      var top;
      // 元素距离底部的高度+元素本身高度
      var bottom;
      this.list.map( (i) => {
        id = document.getElementById(`id${i}`);
        scrollHeight = id.scrollHeight;
        var offsetTop = id.offsetTop;
        top = offsetTop - domHight > 0 ? offsetTop - domHight : 0;
        bottom = scrollHeight + offsetTop;
		
        // 页面滚动位置 > 元素距离顶部高度-窗口高度 && 页面滚动位置 < 元素距离顶部高度+元素本身高度
        if (scroll > offsetTop-600) {
          console.log('元素出现在可视区: ' + i);
        } else {
          console.log('元素不在了: ' + i);
        }
      });
    },
  },
}
</script>

<style >
  .ulBox {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    
  }
  .li {
    width: 100%;
    height: 5rem;
    border: 1px solid #999999;
    display: flex;
    justify-content: center;
    align-items: center;
  } 
</style>
